<template>
    <div class="header-search" :class="{'header-search--open': show}">
        <div v-show="show" @click.stop class="header-search__bg" @click="show = false"></div>
        <div class="header-search__content">
            <div class="header-search__form">
                <i class="fa fa-search header-search__icon-search" @click="focusSearchInput"></i>
                <input
                        ref="focusThis"
                        v-model="query"
                        type="text"
                        class="header-search__input"
                        placeholder="Поиск и фильтр, введите номер заказа, номер телефона или описание"
                        @focus="show = true"
                >
                <i v-if="show" @click="show = false" class="fa fa-times header-search__icon-times"></i>
            </div>
            <div v-show="show" @click.stop class="header-search__filter-wrapper">
                <div v-if="query.length > 1">
                    <div class="header-search__filter-wrapper-custom-scroll">
                        <div v-if="loading.search">
                            <loading :size="3" message="Ищем заказы..."></loading>
                        </div>
                        <div v-else-if="result.length > 0" v-for="order in result" class="header-search__result">
                            <div class="row header-search__result-item" @click.prevent="showOrderDetail(order.id)">
                                <div class="col-2 col-md-1">
                                    №{{order.id}}
                                </div>
                                <div class="col-5 col-md-2 col-lg-1 col-xl-2">
                                    {{order.date}} в {{order.time}}
                                </div>
                                <div class="col-5 col-md-2 col-lg-1 col-xl-2">
                                    <order-status :order="order" :disabled="true"></order-status>
                                </div>
                                <div class="col-12 col-md-7 col-lg-4 col-xl-7 mt-1 mb-1 mb-xl-1 mt-md-0 mb-lg-0">
                                    {{order.description}}
                                    <div class="text-danger small" v-if="order.status.code === 'canceled' && order.cancelCause">Причина отмены: {{order.cancelCause}}</div>
                                </div>
                                <div class="col-6 col-md-5 col-lg-2 col-xl-5"><span v-if="order.clientPhone">+7</span>{{order.clientPhone}} {{order.clientName}}
                                    <div class="small">Ответственный {{order.user.firstname}} {{order.user.lastname}}</div>
                                </div>
                                <div class="col-6 col-md-7 col-lg-3 col-xl-7">
                                    <span class="text-muted"><i class="fa fa-map-marker"></i> {{order.techcenter.city.name}} - {{order.techcenter.company.name}}</span><br>
                                    <span class="badge" :style="{ backgroundColor: order.techcenter.color }">{{order.techcenter.address}}</span><br>
                                </div>
                            </div>
                        </div>
                        <div v-else class="alert alert-warning">
                            <p>К сожалению по указанным вами параметрам не найдено ни одного заказа. Попробуйте изменить параметры поиска или воспользуйтесь <a href="#" @click.prevent="query = ''">подбром по фильтрам</a></p>
                        </div>
                    </div>
                    <div class="header-search__filter-footer">
                        <button class="btn btn-secondary mr-1" @click.prevent="query = ''">Показать фильтр</button>
                    </div>
                </div>
                <template v-else>
                <div class="header-search__filter-wrapper-custom-scroll">
                    <div class="row">
                    <div class="col-12 col-md-4 col-lg-3">
                        <h6><b>Сохраненные фильтры</b></h6>
                        <ul v-if="filters.length > 0" class="header-search__list-group">
                            <li v-for="(filter, index) in filters" @click="activeFilter(filter, index)" :class="{ 'header-search__list-group-item--active': activeFilterIndex === index}"
                                class="header-search__list-group-item d-flex justify-content-between align-items-center">
                                {{filter.name}}
                                <span class="badge badge-secondary header-search__badge-times" @click.stop="removeFilter(index)"><i class="fa fa-times"></i></span>
                            </li>
                        </ul>
                        <div v-else class="alert alert-warning">
                            <p>У вас еще нет ни одного сохранненого фильтра.</p>
                            <p class="hidden-md-down">Но вы можете создать требуемые для вас фильтры в правой колонке.</p>
                        </div>
                    </div>
                    <div class="col-12 col-md-8 col-lg-9 header-search__filter-wrapper-left">
                        <form action="" method="post" сlass="form-horizontal" @submit.prevent>
                            <div class="alert alert-danger" v-if="$v.formParams.$invalid">
                                Номер заказа или период должны быть обязательно указаны
                            </div>
                            <div class="form-group row">
                                <label class="col-md-3 form-control-label">Номера заказов</label>
                                <div class="col-md-9">
                                    <multiselect
                                            v-model="formParams.ordersIds"
                                            tag-placeholder="Нажмите Enter для добавления"
                                            placeholder="Введите номера заказов"
                                            label="id"
                                            track-by="name"
                                            :options="formParams.ordersIds"
                                            :multiple="true"
                                            :taggable="true"
                                            @tag="addOrderId"
                                            @select="$v.formParams.ordersIds.$touch()"
                                            @remove="$v.formParams.ordersIds.$touch()"
                                    ></multiselect>
                                </div>
                            </div>
                            <div class="form-group row">
                                <label class="col-md-3 form-control-label">Период</label>
                                <div class="col-md-9">
                                    <DateRangePicker
                                            v-model="formParams.dates"
                                            class="header-search__date-range-picker"
                                            :range="true"
                                            :format="format"
                                            lang="ru"
                                            width="240"
                                            :first-day-of-week="1"
                                            :shortcuts="false"
                                            input-class="form-control"
                                    >
                                    </DateRangePicker>
                                </div>
                            </div>
                            <div class="form-group row">
                                <label class="col-md-3 form-control-label">Город</label>
                                <div class="col-md-9">
                                    <multiselect
                                            v-model="formParams.cities"
                                            :options="cities"
                                            :searchable="true"
                                            :close-on-select="true"
                                            placeholder="Выберите город"
                                            track-by="id" label="name"
                                            :multiple="true"
                                            select-label="Нажмите enter чтобы добавить"
                                            deselect-label="Нажмите enter чтобы удалить"
                                            selected-label="Выбрано"
                                    >

                                    </multiselect>
                                </div>
                            </div>
                            <div class="form-group row">
                                <label class="col-md-3 form-control-label">Компания</label>
                                <div class="col-md-9">
                                    <multiselect
                                            v-model="formParams.companies"
                                            :options="companies"
                                            :searchable="true"
                                            :close-on-select="true"
                                            placeholder="Выберите компанию"
                                            track-by="id" label="name"
                                            :multiple="true"
                                            select-label="Нажмите enter чтобы добавить"
                                            deselect-label="Нажмите enter чтобы удалить"
                                            selected-label="Выбрано"
                                            :loading="loading.companies"
                                    >

                                    </multiselect>
                                </div>
                            </div>
                            <div class="form-group row">
                                <label class="col-md-3 form-control-label">Техцентр</label>
                                <div class="col-md-9">
                                    <multiselect
                                            v-model="formParams.techcenters"
                                            :options="techcenters"
                                            :searchable="true"
                                            :close-on-select="true"
                                            placeholder="Выберите техцентр"
                                            track-by="id" label="name"
                                            :multiple="true"
                                            select-label="Нажмите enter чтобы добавить"
                                            deselect-label="Нажмите enter чтобы удалить"
                                            selected-label="Выбрано"
                                            :loading="loading.techcenters"
                                    >

                                    </multiselect>
                                </div>
                            </div>
                            <div class="form-group row">
                                <label class="col-md-3 form-control-label">Ответственный</label>
                                <div class="col-md-9">
                                    <multiselect
                                            v-model="formParams.users"
                                            :options="users"
                                            :searchable="true"
                                            :close-on-select="true"
                                            placeholder="Выберите пользователей"
                                            track-by="id" label="fullname"
                                            :multiple="true"
                                            select-label="Нажмите enter чтобы добавить"
                                            deselect-label="Нажмите enter чтобы удалить"
                                            selected-label="Выбрано"
                                            :loading="loading.users"
                                    >
                                    </multiselect>
                                </div>
                            </div>
                            <div class="form-group row">
                                <label class="col-md-3 form-control-label">Статус заказа</label>
                                <div class="col-md-9">
                                    <multiselect
                                            v-model="formParams.statuses"
                                            :options="statuses"
                                            :searchable="true"
                                            :close-on-select="true"
                                            placeholder="Выберите статус"
                                            track-by="id" label="name"
                                            :multiple="true"
                                            select-label="Нажмите enter чтобы добавить"
                                            deselect-label="Нажмите enter чтобы удалить"
                                            selected-label="Выбрано"
                                    >

                                    </multiselect>
                                </div>
                            </div>
                            <div class="form-group row">
                                <label class="col-md-3 form-control-label">Только проблемные заказы</label>
                                <div class="col-md-9">
                                    <label class="switch switch-lg switch-3d switch-primary ml-1">
                                        <input v-model="formParams.problem"  type="checkbox" class="switch-input">
                                        <span class="switch-label"></span>
                                        <span class="switch-handle"></span>
                                    </label>
                                </div>
                            </div>
                            <div class="form-group row">
                                <label class="col-md-3 form-control-label">Только отменные заказы</label>
                                <div class="col-md-9">
                                    <label class="switch switch-lg switch-3d switch-primary ml-1">
                                        <input v-model="formParams.canceled"  type="checkbox" class="switch-input">
                                        <span class="switch-label"></span>
                                        <span class="switch-handle"></span>
                                    </label>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
                </div>
                <div class="header-search__filter-footer">
                    <div class="row">
                        <div class="col-12 col-md-9 offset-lg-3">
                            <template  v-if="$v.formParams.$invalid">
                                <button disabled class="btn btn-primary disabled" @click.prevent>Применить</button>&nbsp;
                            </template>
                            <template v-else>
                                <button class="btn btn-primary" @click.prevent="search">Применить</button>&nbsp;
                            </template>
                            <button class="btn btn-secondary" @click.prevent v-b-modal.saveSearchFilter>Сохранить фильтр</button>&nbsp;
                            <button class="btn btn-link" @click.prevent="clearFiltersParams">Сбросить</button>&nbsp;
                            <button class="btn btn-link" @click.prevent="show = false">Скрыть</button>&nbsp;
                        </div>
                    </div>
                </div>
                </template>
            </div>
        </div>
        <!-- Modal Component -->
        <b-modal :lazy="true"
                 id="saveSearchFilter"
                 @shown="focusFilterItemInput"
                 ok-title="Сохранить"
                 cancel-title="Отменить"
                 title="Сохранить фильтр"
                 @ok="saveFilter"
        >
            Введите название фильтра
            <input class="form-control" ref="focusModalThis" v-model="newFilterName" type="text">
        </b-modal>
    </div>
</template>
<script>
  import { mapState, mapActions } from 'vuex'
  import { ADD_TOAST_MESSAGE } from 'vuex-toast'
  import Multiselect from 'vue-multiselect'
  import DateRangePicker from 'vue2-datepicker'
  import getTechcentersQuery from 'gql/queries/getTechcenters.graphql'
  import getCompaniesQuery from 'gql/queries/getCompanies.graphql'
  import getUsers from 'gql/queries/getUsersForMultiselect.graphql'
  import getOrdersQuery from 'gql/queries/getOrders.graphql'
  import OrderStatus from './../views/Orders/OrderStatus.vue'
  import moment from 'moment'
  import { requiredIf } from 'vuelidate/lib/validators'
  export default {
    name: 'header-search-input',
    computed: {
      ...mapState({
        cities: state => state.globalStore.cities,
        statuses: state => state.globalStore.statuses
      })
    },
    components: {
      Multiselect,
      DateRangePicker,
      OrderStatus
    },
    watch: {
      query: function (queryString) {
        if (queryString.length > 1) {
          this.loading.search = true
          this.$apollo.query({
            query: getOrdersQuery,
            variables: {
              query: queryString,
              limit: 20
            }
          }).then(result => {
            this.loading.search = false
            this.result = result.data.orders
          }).catch(error => {
            this.loading.search = true
            console.log(error)
          })
        }
      }
    },
    data () {
      return {
        format: 'DD/MM/YYYY',
        query: '',
        show: false,
        companies: [],
        techcenters: [],
        users: [],
        result: [],
        formParams: {
          ordersIds: [],
          cities: [],
          companies: [],
          techcenters: [],
          users: [],
          statuses: [],
          dates: {},
          problem: null,
          canceled: null
        },
        activeFilterIndex: null,
        filters: [],
        loading: {
          companies: false,
          techcenters: false,
          users: false,
          search: false
        },
        newFilterName: ''
      }
    },
    methods: {
      showOrderDetail (id) {
        this.show = false
        this.$store.dispatch('showOrderDetail', id)
      },
      addOrderId (id) {
        id = parseInt(id)
        if (id > 0) {
          const OrderId = {
            id: parseInt(id),
            name: '№' + parseInt(id)
          }
          this.formParams.ordersIds.push(OrderId)
          this.$v.formParams.ordersIds.$touch()
        } else {
          this.addToast({
            text: 'Номер заказа должен состоять из цифр',
            type: 'danger',
            dismissAfter: 2000
          })
        }
      },
      clearFiltersParams () {
        this.formParams = {
          ordersIds: [],
          cities: [],
          companies: [],
          techcenters: [],
          users: [],
          statuses: [],
          dates: {},
          problem: null,
          canceled: null
        }
        this.activeFilterIndex = null
      },
      activeFilter (filter, index) {
        this.activeFilterIndex = index
        this.formParams = Object.assign({}, filter.params)
      },
      removeFilter (index) {
        this.filters.splice(index, 1)
        window.localStorage.setItem('filters', JSON.stringify(this.filters))
      },
      saveFilter () {
        if (this.newFilterName.length > 0) {
          const filter = {
            name: this.newFilterName,
            params: this.formParams,
            active: false
          }
          this.filters.push(filter)
          window.localStorage.setItem('filters', JSON.stringify(this.filters))
          this.newFilterName = ''
        }
      },
      focusFilterItemInput () {
        this.$refs.focusModalThis.focus()
      },
      focusSearchInput () {
        this.$refs.focusThis.focus()
      },
      search () {
        this.$router.push({name: 'Orders'})
        let params = {
          dateFrom: null,
          dateTo: null,
          id: this.formParams.ordersIds.map(function (item) {
            return item.id
          }),
          cityId: this.formParams.cities.map(function (item) {
            return item.id
          }),
          companyId: this.formParams.companies.map(function (item) {
            return item.id
          }),
          techcenterId: this.formParams.techcenters.map(function (item) {
            return item.id
          }),
          userId: this.formParams.users.map(function (item) {
            return item.id
          }),
          status: this.formParams.statuses.map(function (item) {
            return item.code
          }),
          problem: this.formParams.problem ? true : null,
          canceled: this.formParams.canceled ? true : null
        }
        if (this.formParams.dates[0]) {
          params.dateFrom = moment(this.formParams.dates[0], this.format).format('DD.MM.YYYY').toString()
        }
        if (this.formParams.dates[0]) {
          params.dateTo = moment(this.formParams.dates[1], this.format).format('DD.MM.YYYY').toString()
        }
        this.$store.dispatch('getOrders', params).then(() => {
          window.localStorage.setItem('displayModeParams', JSON.stringify(params))
          window.localStorage.setItem('displayMode', 'search')
        }).catch((error) => {
          this.addToast({
            text: 'Произошла ошибка при загрузке заказов:' + error + '. Отображается результат предыдущего поиска',
            type: 'danger',
            dismissAfter: 10000
          })
        })
        this.show = false
      },
      loadFilters () {
        if (window.localStorage.getItem('filters')) {
          this.filters = JSON.parse(window.localStorage.getItem('filters'))
        }
      },
      ...mapActions({
        addToast: ADD_TOAST_MESSAGE
      })
    },
    apollo: {
      companies: {
        query: getCompaniesQuery,
        variables () {
          return {
            cityIds: this.formParams.cities.map(function (item) {
              return item.id
            }),
            all: true
          }
        },
        watchLoading (isLoading) {
          this.loading.companies = isLoading
        },
        error (error) {
          console.error('We\'ve got an error!', error)
        }
      },
      techcenters: {
        query: getTechcentersQuery,
        variables () {
          return {
            cityIds: this.formParams.cities.map(function (item) {
              return item.id
            }),
            companyIds: this.formParams.companies.map(function (item) {
              return item.id
            }),
            all: true
          }
        },
        watchLoading (isLoading) {
          this.loading.techcenters = isLoading
        },
        error (error) {
          console.error('We\'ve got an error!', error)
        }
      },
      users: {
        query: getUsers,
        watchLoading (isLoading) {
          this.loading.users = isLoading
        },
        error (error) {
          console.error('We\'ve got an error!', error)
        }
      }
    },
    validations () {
      return {
        formParams: {
          dates: {
            required: requiredIf((ordersIds) => {
              return this.formParams.ordersIds.length === 0
            })
          },
          ordersIds: {
            required: requiredIf((ordersIds) => {
              return !this.formParams.dates
            })
          }
        }
      }
    },
    created () {
      this.loadFilters()
      this.clearFiltersParams()
      this.$root.$on('focusOnHeaderSearchInput', this.focusSearchInput)
    }
  }
</script>



// WEBPACK FOOTER //
// HeaderSearchInput.vue?f9cdf4b6